<button
  headerStart
  class="hamburger-btn"
  type="button"
  (click)="openDrawer()"
  [attr.aria-label]="'MOBILE_NAV.OPEN_MENU' | translate"
>
  <mat-icon>menu</mat-icon>
</button>

<ng-template #drawerPortalContent>
  @let user = selectUser$ | async;

  <div
    class="drawer-backdrop"
    [class.open]="isDrawerOpen()"
    #drawerBackdrop
    (click)="close()"
  ></div>

  <aside
    class="drawer-panel"
    [class.rtl]="isRtl"
    [class.open]="isDrawerOpen()"
    #drawerPanel
    role="dialog"
    aria-modal="true"
  >
    <div class="drawer-header">
      <button type="button" class="org-card" (click)="openOrgSelector()">
        <ui-avatar
          class="org-avatar"
          [name]="activeOrganization()?.settings?.orgName"
          [color]="activeOrganization()?.settings?.orgColor"
          [fontSize]="14"
        ></ui-avatar>
        <span class="org-text">
          <span class="org-name">{{
            activeOrganization()?.settings?.orgName
          }}</span>
          <span class="org-caption">{{
            'SIDEBAR.SWITCH_ORGANIZATION' | translate
          }}</span>
        </span>
        <span class="org-switch">
          <mat-icon>unfold_more</mat-icon>
        </span>
      </button>
    </div>

    <div class="drawer-scroll">
      <section class="section">
        <div class="nav-card">
          @for (item of navigationItems(); track item.segment) {
            <a
              class="nav-row"
              [class.active]="isActiveRoute(item)"
              (click)="navigateTo(item)"
            >
              <span class="nav-tile">
                <span [class]="item.icon" class="nav-icon"></span>
              </span>
              <span class="nav-label">{{ item.labelKey | translate }}</span>
            </a>
          }
        </div>
      </section>

      <section class="section">
        <div class="section-label">
          {{ 'MOBILE_NAV.USER_SECTION' | translate }}
        </div>
        <div class="nav-card">
          @if (user) {
            <div class="user-row">
              <ui-avatar
                class="user-avatar"
                [name]="user.firstname + ' ' + user.lastname"
                [color]="userAvatarColor"
                [fontSize]="13"
              ></ui-avatar>
              <span class="user-text">
                <span class="user-name"
                  >{{ user.firstname }} {{ user.lastname }}</span
                >
                <span class="user-email">{{ user.email }}</span>
              </span>
            </div>
          }
          @for (item of userItems; track item.segment) {
            <a
              class="nav-row"
              [class.active]="isActiveRoute(item)"
              (click)="navigateTo(item)"
            >
              <span class="nav-tile">
                <span [class]="item.icon" class="nav-icon"></span>
              </span>
              <span class="nav-label">{{ item.labelKey | translate }}</span>
            </a>
          }
        </div>
      </section>

      <section class="section section--logout">
        <div class="nav-card">
          <button type="button" class="nav-row logout" (click)="logout()">
            <span class="nav-label">{{ 'MOBILE_NAV.LOGOUT' | translate }}</span>
          </button>
        </div>
      </section>
    </div>
  </aside>

  <app-mobile-org-selector
    [isOpen]="isOrgSelectorOpen()"
    [activeOrganization]="activeOrganization()"
    [userOrganizations]="userOrganizations()"
    (closed)="closeOrgSelector()"
  ></app-mobile-org-selector>
</ng-template>
